import { render, staticRenderFns } from "./Begleitfahrt.vue?vue&type=template&id=eaea64c0&scoped=true&"
import script from "./Begleitfahrt.vue?vue&type=script&lang=js&"
export * from "./Begleitfahrt.vue?vue&type=script&lang=js&"
import style0 from "./Begleitfahrt.vue?vue&type=style&index=0&id=eaea64c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaea64c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VList})
